import React from "react";
import { Typography } from "@material-ui/core";

export const About: React.FC = () => {
  return (
    <>
      <Typography variant="h4" component="h1" gutterBottom>
        About
      </Typography>
      <Typography component="p">Coming soon</Typography>
    </>
  );
};
